import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router } from 'react-router-dom';
import Header from './Components/Header';
import Footer from './Components/Footer';
import Routers from './Routers';
import NewsTicker from './Components/NewsTicker';

function App() {
  return (
    <>
      <Router>
      <div data-elementor-type="wp-page" data-elementor-id="6" class="elementor elementor-6">
        <Header />
        <Routers />
        <NewsTicker />
        <Footer />
        </div>
      </Router>
    </>
  );
}

export default App;
